import moment from "moment";

/**
 * Compute (start, end) interval to filter job results starting
 * from a required minimum "recency" for any job.
 * @param recencyInSeconds {number}
 * @return {{start: number, end: number}}
 */
const computeDateRange = (recencyInSeconds) => {
  const now = moment().utc();
  const start = now.clone().subtract(recencyInSeconds, "seconds");
  return {
    start: start.unix(),
    end: now.unix(),
  };
};

export default computeDateRange;
